// "use client";
// import React, { useState } from "react";
// import Header from "./Header";
// import Airports from "./Airports";
// import AirportsData from "../data/airport-page/all-airports.json";
// import TawkTo from "../componenets/Tawko";

// const page = () => {

//   const [filteredAirports, setFilteredAirports] = useState(AirportsData);

//   // Callback function to handle search
//   const handleSearch = (searchTerm) => {
//     const filtered = AirportsData.filter(
//       (airport) =>
//         airport.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         airport.code.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredAirports(filtered);
//   };
//   // console.log(filteredAirports);
//   return (
//     <div>
//       <TawkTo />
//       <Header onSearch={handleSearch} />
//       <Airports filteredAirports={filteredAirports} />
//     </div>
//   );
// };

// export default page;

'use client';
import React, { useState } from 'react';
import Header from './Header';
import Airports from './Airports';
import AirportsData from '../data/airport-page/all-airports.json';
import TawkTo from '../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
const page = () => {
  // Sort the airports alphabetically by name
  const sortedAirports = AirportsData.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const [filteredAirports, setFilteredAirports] = useState(sortedAirports);

  // Callback function to handle search
  const handleSearch = (searchTerm) => {
    const filtered = AirportsData.filter(
      (airport) =>
        airport.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        airport.code.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredAirports(filtered);
  };

  return (
    <div>
      <title>Top USA Airports: Travel Guide & Key Information</title>
      <meta
        name="description"
        content="Explore major USA airports, key facilities, and travel tips for a smooth journey across top U.S. destinations. Plan your airport experience today."
      />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link rel="canonical" href="https://www.prestigeride.com/airports" />

      <TawkTo />
      <Navbar />
      <Header onSearch={handleSearch} />
      <Airports filteredAirports={filteredAirports} />
      <Footer />
    </div>
  );
};

export default page;
